import { getTilesToken, invalidateTilesToken } from './tiles-token.service';

type FetchInput = Parameters<typeof fetch>[0];
type FetchInit = NonNullable<Parameters<typeof fetch>[1]>;
type FetchHeaders = NonNullable<FetchInit['headers']>;

const withAuthorizationHeader = async (headers: FetchHeaders = {}) => {
  const token = await getTilesToken();

  const normalizedHeaders = new Headers(headers);
  normalizedHeaders.set('Authorization', `Bearer ${token}`);

  return normalizedHeaders;
};

const fetchTilesWithAuth = async (input: FetchInput, init: FetchInit = {}) => {
  const headers = await withAuthorizationHeader(init.headers);

  const response = await fetch(input, {
    ...init,
    headers,
  });

  if (response.status === 401) {
    invalidateTilesToken();
  }

  return response;
};

export default fetchTilesWithAuth;
